export default __webpack_public_path__ + "static/media/Vector.4bb7aeb8.svg";